var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "stepsBox" },
    [
      _vm._m(0),
      _vm._v(" "),
      _c(
        "el-steps",
        { attrs: { direction: "vertical", active: _vm.indexCheck } },
        _vm._l(_vm.examineList, function (item, index) {
          return _c("el-step", { key: index }, [
            _c(
              "div",
              {
                staticClass: "caption",
                attrs: { slot: "title" },
                on: {
                  click: function ($event) {
                    return _vm.itemIsShow(item)
                  },
                },
                slot: "title",
              },
              [
                _vm._v("\n        " + _vm._s(item.title) + "\n        "),
                item.types == 1 &&
                item.settype != 5 &&
                item.examine_mode > 0 &&
                item.users.length > 1
                  ? _c("el-tag", { attrs: { effect: "plain", size: "mini" } }, [
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm.getExamineText(item.examine_mode)) +
                          "\n        "
                      ),
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _c("i", {
                  class: !_vm.hiddenKey.includes(item.uniqued)
                    ? "el-icon-caret-top"
                    : "el-icon-caret-bottom",
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "liuchen", attrs: { slot: "icon" }, slot: "icon" },
              [
                _c("i", {
                  class:
                    item.types == 1 ? "el-icon-s-check" : "el-icon-s-promotion",
                }),
              ]
            ),
            _vm._v(" "),
            _c("div", { attrs: { slot: "description" }, slot: "description" }, [
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: !_vm.hiddenKey.includes(item.uniqued),
                      expression: "!hiddenKey.includes(item.uniqued)",
                    },
                  ],
                },
                _vm._l(item.users, function (items, indexs) {
                  return _c(
                    "div",
                    { key: indexs, staticClass: "manList row-between-wrapper" },
                    [
                      _c(
                        "el-row",
                        { staticClass: "center" },
                        [
                          _c(
                            "el-col",
                            {
                              staticClass: "manList-avatar",
                              attrs: { span: 24 },
                            },
                            [
                              _c("div", { staticClass: "manList-icon" }, [
                                _vm.judge(items)
                                  ? _c("img", {
                                      staticClass: "mb10",
                                      attrs: {
                                        src: items.card
                                          ? items.card.avatar
                                          : items.info.card.avatar,
                                      },
                                    })
                                  : _c("img", {
                                      staticClass: "mb10",
                                      attrs: {
                                        src: require("../../../../assets/images/portrait.png"),
                                      },
                                    }),
                                _vm._v(" "),
                                items.status === 1 && item.types !== 2
                                  ? _c(
                                      "span",
                                      { staticClass: "acea-icon acea-success" },
                                      [
                                        _c("i", {
                                          staticClass: "el-icon-check jingshi",
                                        }),
                                      ]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                items.status === 2 && item.types !== 2
                                  ? _c(
                                      "span",
                                      { staticClass: "acea-icon acea-warning" },
                                      [
                                        _c("span", { staticClass: "jingshi" }, [
                                          _vm._v("！"),
                                        ]),
                                      ]
                                    )
                                  : _vm._e(),
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "name" }, [
                                _c("span", [
                                  _vm._v(
                                    _vm._s(
                                      items.card
                                        ? items.card.name
                                        : items.info.card.name
                                    ) + "\n                    "
                                  ),
                                  items.status > 0
                                    ? _c("span", { staticClass: "time" }, [
                                        _vm._v(
                                          "\n                      " +
                                            _vm._s(items.updated_at) +
                                            "\n                    "
                                        ),
                                      ])
                                    : _vm._e(),
                                ]),
                                _vm._v(" "),
                                _c(
                                  "span",
                                  {
                                    staticClass: "status-text",
                                    style: {
                                      color:
                                        items.status == 1 && item.types == 1
                                          ? "#19BE6B"
                                          : "",
                                    },
                                  },
                                  [
                                    _vm._v(
                                      "\n                    " +
                                        _vm._s(
                                          _vm.getDetailText(
                                            item.types,
                                            items.status
                                          )
                                        )
                                    ),
                                  ]
                                ),
                              ]),
                            ]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                }),
                0
              ),
            ]),
          ])
        }),
        1
      ),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "acea-row mb25" }, [
      _c("div", { staticClass: "shu mr10" }),
      _vm._v(" "),
      _c("span", { staticClass: "title" }, [_vm._v("审批进程")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }